var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "relative" },
    [
      _c("div", { staticClass: "flex" }, [
        _c(
          "button",
          {
            staticClass:
              "mt-2 p-1 text-gray-200 rounded-full focus:outline-none focus:text-white",
            class: _vm.toggleStyle,
            on: { click: _vm.toggleDropdown },
          },
          [
            _c("BellIcon", {
              staticClass: "h-6 w-6 text-gray-400 hover:text-primary-500",
              class: _vm.iconStyle,
            }),
          ],
          1
        ),
      ]),
      _vm.listShown
        ? _c("NotificationsList", {
            attrs: { currentUserId: _vm.currentUserId },
            on: {
              close: function ($event) {
                _vm.listShown = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }